import { NavWrap } from './style';
import React from 'react';
import { INavProp } from '../member-page';
export const NavDom = ({ navList, handleScrollToBottom }: INavProp) => {
	return (
		<NavWrap>
			{navList.map((item) => {
				return (
					<div key={item.key} onClick={() => handleScrollToBottom(item.key)} alt-tip={JSON.stringify({ tit: item.tip, time: 3 })}>
						<div className="num">
							<div>{item.num}</div>
							<img src={item.img} />
						</div>
						<div className="content">{item.tit}</div>
					</div>
				);
			})}
		</NavWrap>
	);
};
